import type { HelpFile } from '../../types/help'
import { SpanDetailSheetTestIds } from '../../../testids/SpanDetailSheetTestIds'

export const spanDetailSheetHelp: HelpFile = {
  docPage: '/docs/admin/request-inspector',
  texts: {
    [SpanDetailSheetTestIds.spanDetailSheet]: 'Detailbereich für einen Span im Anfrage-Trace. Wechsle die Tabs, um Attribute, HTTP-Daten, SQL-Anweisungen oder den erfassten Fehler zu prüfen.',
    [SpanDetailSheetTestIds.tabHttp]: 'HTTP-Methode, Statuscode, URL sowie Anfrage- und Antwortgrößen, die für diesen Span erfasst wurden.',
    [SpanDetailSheetTestIds.tabSql]: 'SQL-Anweisung, Parameter und Ausführungsdauer, die innerhalb dieses Spans aufgezeichnet wurden.',
    [SpanDetailSheetTestIds.tabError]: 'In diesem Span aufgetretene Ausnahme — Typ, Meldung und Stack-Trace.',
    [SpanDetailSheetTestIds.attributesJson]: 'Roher OpenTelemetry-Attributsatz des Spans. Nützlich bei Spans, für die die UI keine spezielle Ansicht hat.',
    [SpanDetailSheetTestIds.btnViewErrorLog]: 'Den passenden Fehlerprotokolleintrag öffnen, um den vollständigen Anfragekontext und weitere Vorkommen zu sehen.',
    [SpanDetailSheetTestIds.linkViewErrorLog]: 'Zum passenden Fehlerprotokolleintrag dieses Spans springen.',
  },
}
